<template>
  <nav class="creek-shows-nav">
    <ul>
      <li :class="['creek-shows-nav-weekday', 'creek-weekday-' + weekdayNumber, weekdayNumber == pageSelected ? 'creek-selected' : '' ]" v-for="(weekdayTitle, weekdayNumber) in showsNavText.weekdays"><a :href="'#/weekday/' + weekdayNumber" :data-weekday="weekdayNumber" v-html="weekdayTitle"></a></li>
      <li class="creek-shows-nav-all" :class="[ pageSelected == 'all' ? 'creek-selected' : '' ]"><a href="#/all" v-html="showsNavText.allShows"></a></li>
      <li class="creek-shows-nav-calendar" :class="[ pageSelected == 'calendar' ? 'creek-selected' : '' ]"><a href="#/calendar" v-html="showsNavText.calendar"></a></li>
    </ul>
  </nav>
</template>

<script type="text/javascript">
export default {
  name: 'creek-shows-nav',
  props: ['showsNavText', 'pageSelected'],
  data () {
    return {
    }
  }
}
</script>